export const uiSocialShare = {
    name: 'UI Social Share',
    description: '',
    displayField: 'text',
    fields: {
        text: {
            name: 'Text',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [{ size: { min: 0, max: 240 } }]
        },
        hashtags: {
            name: 'Hashtags',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: { type: 'Symbol', validations: [] }
        },
        facebookButtonText: {
            name: 'Facebook Button Text',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        twitterButtonText: {
            name: 'Twitter Button Text',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiSocialShare.js.map